import { createTheme } from '@mui/material/styles';

import { themeAssure } from '../parcours/theme';

/**
 * L'identité d'Iziclai, resserrée pour un outil de travail.
 *
 * Le thème de l'assuré respire : il arrive une fois, secoué par un sinistre,
 * et doit tout comprendre. L'expert, lui, passe sa journée ici et lit trente
 * dossiers — la même palette, mais des lignes plus serrées et une typographie
 * plus petite, pour qu'une liste tienne à l'écran sans faire défiler.
 *
 * On dérive du thème assuré plutôt que de le recopier : la couleur reste
 * définie à un seul endroit, et les deux fronts ne peuvent pas diverger.
 */
export const themeExpert = createTheme(themeAssure, {
  shape: { borderRadius: 8 },
  typography: {
    h1: { fontSize: '1.5rem', fontWeight: 600, letterSpacing: '-0.01em' },
    h2: { fontSize: '1.2rem', fontWeight: 600 },
    h3: { fontSize: '1rem', fontWeight: 600 },
    body1: { fontSize: '0.9rem', lineHeight: 1.5 },
    body2: { fontSize: '0.85rem', lineHeight: 1.5 },
  },
  components: {
    MuiButton: {
      styleOverrides: { root: { paddingInline: 16, paddingBlock: 6 } },
    },
    MuiTextField: { defaultProps: { size: 'small', fullWidth: true } },
    MuiTableCell: {
      styleOverrides: {
        root: { paddingBlock: 10 },
        head: { fontWeight: 600, whiteSpace: 'nowrap' },
      },
    },
  },
});

export default themeExpert;
